import React, { useMemo } from 'react';
import { useCurrencyContext } from '~/context/CurrencyContext';
import { useCurrenciesListContext } from '~/context/CurrencyListContext';
import SelectMenuItem from '~/reusable-components/navigation/NavigationMenuList/SelectMenuItem';

function CurrencyMenuItem() {
  const { state, actions } = useCurrencyContext();
  const { state: currenciesListState } = useCurrenciesListContext();
  const { currencies, loading } = currenciesListState;

  const options = useMemo(() => {
    return currencies.map(({ symbol_native, code }) => ({
      value: code,
      label: `${code} - (${symbol_native})`,
    }));
  }, [currencies]);

  const onCurrencyChange = (newValue) => {
    actions.setCurrency(newValue);
  };

  if (loading || options.length === 0) {
    return null; // Or you could render a loading state or placeholder
  }

  return (
    <SelectMenuItem
      selectedItem={state.currency}
      options={options}
      onSelect={onCurrencyChange}
      label="Currency"
    />
  );
}

export default CurrencyMenuItem;
